import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-back-to-top-doc',
  templateUrl: './back-to-top-doc.component.html',
  styleUrls: ['./back-to-top-doc.component.scss']
})
export class BackToTopDocComponent implements OnInit {

  utils: any;
  highlighted: boolean = false;
  codeHtml: string;
  codeJs: string;
  infoComponent: { titulo: string; descripcion: string; };
  constructor(
    private highlightService: HighlightService) {
    this.utils = window.utils;
    this.codeHtml = `
        <div class="scroll-to-top show-scrollTop">
          <button onClick={this.scrollToTop.bind(this)}>
              <span class="govco-icon govco-icon-shortu-arrow-n btn-svg-up-hover">
              </span>
              <span class="label-button-star-up"> Volver a arriba </span>
          </button>
      </div>
    `,
    this.infoComponent = {
			titulo: 'Volver arriba',
			descripcion:
				'El componente Volver arriba (Back to Top), hace parte de los componentes maestros este componente debe contener siempre el el logo de GOV.CO.'
    }
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngOnInit() {
    this.utils.init();
  }
}
